/* ==========================================================
   CIGAR DIP™ Luxury Product Engine
   Version 1.0
   ========================================================== */

(() => {

'use strict';

/* ============================================
   Utilities
============================================ */

const $$ = (selector,parent=document)=>[
...parent.querySelectorAll(selector)
];

const $ = (selector,parent=document)=>
parent.querySelector(selector);

/* ============================================
   Scroll Reveal
============================================ */

const revealItems = $$(
'.product-block,.product__photos,.product-single__meta,.sales-point'
);

if("IntersectionObserver" in window){

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("cd-visible");

}

});

},{
threshold:.18
});

revealItems.forEach(item=>{

item.classList.add("cd-reveal");

observer.observe(item);

});

}

/* ============================================
   Gallery Tilt
============================================ */

const gallery=$(
'.product__photos,.product-single__photos'
);

if(gallery){

gallery.addEventListener("mousemove",e=>{

const rect=gallery.getBoundingClientRect();

const x=e.clientX-rect.left;

const y=e.clientY-rect.top;

const rotateY=(x/rect.width-.5)*10;

const rotateX=(.5-y/rect.height)*8;

gallery.style.transform=`
perspective(1400px)
rotateX(${rotateX}deg)
rotateY(${rotateY}deg)
scale(1.015)
`;

});

gallery.addEventListener("mouseleave",()=>{

gallery.style.transform="";

});

}

/* ============================================
   Buy Box Spotlight
============================================ */

const buyBox=$(".product-single__meta");

if(buyBox){

buyBox.addEventListener("mousemove",e=>{

const rect=buyBox.getBoundingClientRect();

const x=e.clientX-rect.left;

const y=e.clientY-rect.top;

buyBox.style.setProperty(
'--mouse-x',
x+"px"
);

buyBox.style.setProperty(
'--mouse-y',
y+"px"
);

});

}

/* ============================================
   Variant Hover Glow
============================================ */

$$(".variant-input label").forEach(label=>{

label.addEventListener("mouseenter",()=>{

label.style.boxShadow=
"0 0 25px rgba(200,161,90,.25)";

});

label.addEventListener("mouseleave",()=>{

label.style.boxShadow="";

});

});

/* ============================================
   Button Press Animation
============================================ */

const buttons=$$(".product-form__cart-submit");

buttons.forEach(button=>{

button.addEventListener("mousedown",()=>{

button.style.transform="scale(.98)";

});

button.addEventListener("mouseup",()=>{

button.style.transform="";

});

button.addEventListener("mouseleave",()=>{

button.style.transform="";

});

});

/* ============================================
   Floating Background Glow
============================================ */

let glow=document.createElement("div");

glow.className="cd-cursor-glow";

document.body.appendChild(glow);

window.addEventListener("mousemove",e=>{

glow.style.left=e.clientX+"px";

glow.style.top=e.clientY+"px";

});

/* ============================================
   Smooth Image Fade
============================================ */

$$(".product__photo img").forEach(img=>{

if(img.complete){

img.classList.add("cd-loaded");

}else{

img.onload=()=>{

img.classList.add("cd-loaded");

}

}

});

})();
/* ===========================================
   Luxury Lightbox
=========================================== */

(function(){

const galleryImage=document.querySelector(
'.product__photo img,.product-single__photo img'
);

if(!galleryImage) return;

const lightbox=document.createElement("div");

lightbox.className="cd-lightbox";

lightbox.innerHTML=`

<div class="cd-lightbox-close">&times;</div>

<img src="" alt="">

<div class="cd-lightbox-toolbar">

<button class="cd-lightbox-btn" data-zoom="in">+</button>

<button class="cd-lightbox-btn" data-zoom="out">−</button>

<button class="cd-lightbox-btn" data-reset>⟳</button>

</div>

`;

document.body.appendChild(lightbox);

const img=lightbox.querySelector("img");

let scale=1;

galleryImage.addEventListener("click",()=>{

img.src=galleryImage.src;

scale=1;

img.style.transform="scale(1)";

lightbox.classList.add("active");

});

lightbox.querySelector(".cd-lightbox-close")
.addEventListener("click",()=>{

lightbox.classList.remove("active");

});

lightbox.addEventListener("click",e=>{

if(e.target===lightbox){

lightbox.classList.remove("active");

}

});

document.addEventListener("keydown",e=>{

if(e.key==="Escape"){

lightbox.classList.remove("active");

}

});

lightbox.querySelector('[data-zoom="in"]')
.addEventListener("click",()=>{

scale=Math.min(scale+.25,4);

img.style.transform=`scale(${scale})`;

});

lightbox.querySelector('[data-zoom="out"]')
.addEventListener("click",()=>{

scale=Math.max(scale-.25,1);

img.style.transform=`scale(${scale})`;

});

lightbox.querySelector("[data-reset]")
.addEventListener("click",()=>{

scale=1;

img.style.transform="scale(1)";

});

})();
/* ==========================================================
   Luxury Zoom Engine
========================================================== */

(function(){

const lightbox=document.querySelector(".cd-lightbox");

if(!lightbox) return;

const image=lightbox.querySelector("img");

let scale=1;

let x=0;

let y=0;

let dragging=false;

let startX=0;

let startY=0;

let velocityX=0;

let velocityY=0;

let animation;

function render(){

image.style.transform=
`translate3d(${x}px,${y}px,0) scale(${scale})`;

}

function clampScale(){

scale=Math.max(1,Math.min(scale,5));

}

lightbox.addEventListener("wheel",e=>{

e.preventDefault();

const delta=e.deltaY>0?-0.12:.12;

scale+=delta;

clampScale();

render();

},{passive:false});

image.addEventListener("mousedown",e=>{

dragging=true;

startX=e.clientX-x;

startY=e.clientY-y;

image.style.cursor="grabbing";

cancelAnimationFrame(animation);

});

window.addEventListener("mousemove",e=>{

if(!dragging) return;

const nx=e.clientX-startX;

const ny=e.clientY-startY;

velocityX=nx-x;

velocityY=ny-y;

x=nx;

y=ny;

render();

});

window.addEventListener("mouseup",()=>{

if(!dragging) return;

dragging=false;

image.style.cursor="grab";

inertia();

});

function inertia(){

function frame(){

velocityX*=0.92;

velocityY*=0.92;

x+=velocityX;

y+=velocityY;

render();

if(

Math.abs(velocityX)>0.3 ||

Math.abs(velocityY)>0.3

){

animation=requestAnimationFrame(frame);

}

}

frame();

}

})();
/* ==========================================================
   Luxury Touch Gestures
========================================================== */

(function(){

const lightbox=document.querySelector(".cd-lightbox");
if(!lightbox) return;

const image=lightbox.querySelector("img");
if(!image) return;

let scale=1;
let translateX=0;
let translateY=0;

let lastTap=0;
let initialDistance=0;
let initialScale=1;

function updateTransform(){
  image.style.transform =
    `translate3d(${translateX}px,${translateY}px,0) scale(${scale})`;
}

function resetView(animated=true){
  scale=1;
  translateX=0;
  translateY=0;

  if(animated){
    image.style.transition="transform .35s cubic-bezier(.22,.61,.36,1)";
  }

  updateTransform();

  setTimeout(()=>{
    image.style.transition="";
  },350);
}

/* ---------- Double Tap ---------- */

image.addEventListener("touchend",e=>{

  const now=Date.now();

  if(now-lastTap<300){

    if(scale===1){

      scale=2;

    }else{

      resetView(false);

    }

    updateTransform();

    e.preventDefault();

  }

  lastTap=now;

});

/* ---------- Pinch ---------- */

function distance(t1,t2){

  return Math.hypot(

    t1.clientX-t2.clientX,

    t1.clientY-t2.clientY

  );

}

image.addEventListener("touchstart",e=>{

  if(e.touches.length===2){

    initialDistance=distance(

      e.touches[0],

      e.touches[1]

    );

    initialScale=scale;

  }

},{passive:false});

image.addEventListener("touchmove",e=>{

  if(e.touches.length!==2) return;

  e.preventDefault();

  const currentDistance=distance(

    e.touches[0],

    e.touches[1]

  );

  scale=initialScale*(currentDistance/initialDistance);

  scale=Math.max(1,Math.min(scale,5));

  updateTransform();

},{passive:false});

/* ---------- Auto Center ---------- */

lightbox.addEventListener("click",e=>{

  if(e.target===lightbox){

    resetView();

  }

});

/* ---------- Keyboard ---------- */

document.addEventListener("keydown",e=>{

  if(!lightbox.classList.contains("active")) return;

  switch(e.key){

    case "0":

      resetView();

      break;

    case "+":
    case "=":

      scale=Math.min(scale+.25,5);

      updateTransform();

      break;

    case "-":

      scale=Math.max(scale-.25,1);

      updateTransform();

      break;

  }

});

})();
/* ==========================================================
   CIGAR DIP™
   Luxury Gallery Pro Layer
   v2.0
========================================================== */

(() => {

const lightbox = document.querySelector(".cd-lightbox");
if (!lightbox) return;

const image = lightbox.querySelector("img");
const toolbar = lightbox.querySelector(".cd-lightbox-toolbar");

let idleTimer;

/* ==========================================
   Idle Cursor Hide
========================================== */

function showCursor(){

    lightbox.classList.remove("cd-idle");

    clearTimeout(idleTimer);

    idleTimer = setTimeout(()=>{

        lightbox.classList.add("cd-idle");

    },1800);

}

["mousemove","touchmove"].forEach(evt=>{

    lightbox.addEventListener(evt,showCursor);

});

showCursor();

/* ==========================================
   Mouse Position Glow
========================================== */

lightbox.addEventListener("mousemove",e=>{

    const rect = lightbox.getBoundingClientRect();

    const x = e.clientX - rect.left;

    const y = e.clientY - rect.top;

    lightbox.style.setProperty("--cursor-x",x+"px");

    lightbox.style.setProperty("--cursor-y",y+"px");

});

/* ==========================================
   Keyboard Navigation
========================================== */

document.addEventListener("keydown",e=>{

    if(!lightbox.classList.contains("active")) return;

    switch(e.key){

        case "ArrowUp":

            image.style.transform += " translateY(-30px)";

        break;

        case "ArrowDown":

            image.style.transform += " translateY(30px)";

        break;

        case "ArrowLeft":

            image.style.transform += " translateX(-30px)";

        break;

        case "ArrowRight":

            image.style.transform += " translateX(30px)";

        break;

    }

});

/* ==========================================
   Loading Shimmer
========================================== */

image.addEventListener("load",()=>{

    lightbox.classList.remove("loading");

});

lightbox.classList.add("loading");

/* ==========================================
   Toolbar Fade
========================================== */

toolbar.addEventListener("mouseenter",()=>{

    toolbar.classList.add("active");

});

toolbar.addEventListener("mouseleave",()=>{

    toolbar.classList.remove("active");

});

/* ==========================================
   Retina Images
========================================== */

if(window.devicePixelRatio>1){

    image.style.imageRendering="auto";

}

})();